import { render } from "./icon-sciscore.vue?vue&type=template&id=1eb9fb80"
import script from "./icon-sciscore.vue?vue&type=script&lang=js"
export * from "./icon-sciscore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__